import * as Pluralize from 'pluralize';
export const pluralize = Pluralize.default;
